var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProtection = function SvgProtection(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 14,
    "data-width-24": 20,
    viewBox: "0 0 13.6 14.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.754 14.139A7.656 7.656 0 0 1 .6 6.63V2.446L6.754.6l6.154 1.846v4.185a7.655 7.655 0 0 1-6.154 7.508"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProtection);
export default ForwardRef;